module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover-image",
    class: _vm.type,
    style: ({
      'background-image': 'url(' + _vm.src + ')'
    })
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.type === 'landing') ? _c('h1', {
    staticClass: "mons-title"
  }, [_vm._v(_vm._s(_vm.$t('title.landing')))]) : _vm._e(), _vm._v(" "), (_vm.type === 'landing') ? _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.theme')))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.type === 'landing') ? _c('div', {
    staticClass: "editor col-12"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.genderLabel)))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))])]) : _vm._e(), _vm._v(" "), (_vm.subtitle && _vm.type !== 'landing') ? _c('h2', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0be37176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/CoverImage.vue
// module id = 495
// module chunks = 1